export default "__VITE_ASSET__CLTRnzSn__"